export class InfoConstants {
  public static INFO = 'info'
  public static INFO_UUID = ':uuid'
}
